"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Button } from '../Button/Button.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { px2rem } from '../utils/helpers/style.js';

var _excluded = ["children", "size"];
var ButtonPillComponent = function ButtonPillComponent(props, ref) {
  var children = props.children,
    _props$size = props.size,
    size = _props$size === undefined ? 'm' : _props$size,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var borderRadius = px2rem(theme.buttonPill.web.borderRadius[size]);
  return /*#__PURE__*/React.createElement(Button, _extends({
    borderRadius: borderRadius,
    ref: ref,
    size: size
  }, rest), children);
};
var ButtonPill = /*#__PURE__*/React.forwardRef(ButtonPillComponent);

export { ButtonPill };
